import { Button } from '@mui/material'
import React from 'react'

export default function BlueCancelButton({startIcon,buttonTitle,onClick, width}) {
  return (
<Button
            variant="contained"
            startIcon={startIcon?startIcon:""}
             onClick={onClick}
            sx={{
              borderRadius: "8px",
              fontSize: "14px",
              fontWeight: 600,
              textTransform: "none",
              backgroundColor: "#57257514",
              color:"#572575",
              width:{width},
              px:3,
              "&:hover": {
                backgroundColor: "#57257514",
                  color:"#572575",
              },
            }}
          >
            {buttonTitle}
          </Button>
  )
}
